<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :filters="filters"
                :columns="columns"
                :disable-permission-checks="true"
                operations="add,edit,delete"
                ref="table">
      <template v-slot:groups="{row}">
        <badge v-if="row.jobs" type="info" class="mr-1">{{$t('generic.jobs')}}</badge>
        <badge v-if="row.organisations" type="info" class="mr-1">{{$t('generic.organisations')}}</badge>
        <badge v-if="row.candidates" type="info">{{$t('generic.candidates')}}</badge>
      </template>
    </data-table>
  </div>
</template>
<script>
  import axios from 'axios'
  import SegmentGroupService from 'src/services/SegmentGroupService'
  import { entities } from 'src/config/routeTypes'
  import Badge from 'src/components/Badge'
  import LanguageSelect from 'src/components/LanguageSelect'
  export default {
    name: 'segments-settings',
    components: {
      Badge,
      LanguageSelect,
    },
    data () {
      return {
        service:  SegmentGroupService,
        entity: entities.SEGMENT_GROUP,
        selectedLocale: this.$i18n.locale,
      }
    },
    computed: {
      filters () {
        return [
          {
            key: 'sort',
            value: '+name'
          }
        ]
      },
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('settings.segments.labels.name'),
            minWidth: '200px',
            sortable: true
          },
          {
            prop: 'groups',
            label: this.$t('settings.segments.labels.groups'),
            minWidth: '200px',
            sortable: true
          }
        ]
      }
    },
  }
</script>
<style>
</style>
